import { color } from './basler-components.es794.js';
import { complex } from './basler-components.es795.js';
import { dimensionValueTypes } from './basler-components.es762.js';
import { testValueType } from './basler-components.es811.js';

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

export { findValueType };
